import React, { useEffect, useState } from "react";
import EpicImg from "../../../assets/images/EpicImg.svg";
import {
  adminIconSvg,
  arrowIconSvg,
  calendarIconSvg,
  conversationIconSvg,
  dashboardIconSvg,
  documentIconSvg,
  editIconSvg,
  integrationsIconSvg,
  locationIconSvg,
  patientIconSvg,
  plusIconSvg,
  recruitersIconSvg,
  trialIconSvg,
  userAccessIconSvg,
} from "../../../assets/icons/side-menu";
import EpicImgSm from "../../../assets/images/EpicImgSm.svg";

import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setViewData } from "../../../reducer/slices/twilio-calls/view-slice";

const Leftbar = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showSubmenu, setShowSubmenu] = useState(false);
  const location = useLocation();
  const isCallInprogress = useSelector((state) => state.call.callData);
  const callViewSize = useSelector((state) => state.callView.callSizeData);
  const callView = useSelector((state) => state.callView.callSizeData);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const routeName = location.pathname.split("/").filter(Boolean).pop();
  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    window.location.href = "/login";
  };
  const [tooltipVisibility, setTooltipVisibility] = useState({});

  const minimizeCall = () => {
    if (isCallInprogress && !callView.isMinView)
      dispatch(
        setViewData({
          isMaxView: true,
          isMinView: true,
        })
      );
  };

  const [openSubmenus, setOpenSubmenus] = useState({});
  const [visibleTooltipIndex, setVisibleTooltipIndex] = useState(null);
  const toggleSubmenu = (index) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
    minimizeCall();
  };

 const menuItems = [
  {
    name: "Dashboard",
    href: "/dashboard",
    icon: dashboardIconSvg,
    key: "Dashboard",
    permissions: ["dashboard_view"], // now an array
  },
  {
    name: "Trials Hub",
    href: "",
    icon: trialIconSvg,
    key: "Trials",
    permissions: ["trials_hub"],
    submenu: [
      {
        name: "Trials Info",
        href: "/trials",
        icon: editIconSvg,
        permissions: ["trial_view", "trial_edit"],
      },
      {
        name: "Create New Trials",
        href: "/create-trial",
        icon: plusIconSvg,
        permissions: ["trial_add"], // supports multiple permissions
      },
      {
        name: "Existing Trials",
        href: "/trial",
        icon: documentIconSvg,
        permissions: ["trial_view"],
      },
    ],
  },
  {
    name: "Patients",
    href: "/patients",
    icon: patientIconSvg,
    key: "Patients",
    permissions: ["patient_view"],
  },
  {
    name: "Calendar",
    href: "/calendar",
    icon: calendarIconSvg,
    key: "Calendar",
    permissions: ["calendar"],
  },
  {
    name: "Conversations",
    href: "/conversation-list",
    icon: conversationIconSvg,
    key: "Conversation-list",
    permissions: ["conversations", "chat_access"], // multiple allowed
  },
  {
    name: "Integrations",
    href: "/integrations",
    icon: integrationsIconSvg,
    key: "Integrations",
    permissions: ["integration"],
  },
  {
    name: "Admin",
    href: "",
    icon: adminIconSvg,
    key: "Admin",
    permissions: ["admin_useraccess", "admin_access"],
    submenu: [
      {
        name: "Locations",
        href: "/locations",
        icon: locationIconSvg,
        permissions: ["admin_location"],
      },
      {
        name: "Recruiters",
        href: "/recruiters",
        icon: recruitersIconSvg,
        permissions: ["admin_recruiter"],
      },
      {
        name: "User Access",
        href: "/user-access",
        icon: userAccessIconSvg,
        permissions: ["admin_useraccess"],
      },
    ],
  },
];

  const filterMenuByPermissions = (menu, userPermissions) => {
  return menu
    .map(item => {
      // Check if user has any matching permission
      const hasPermission =
        !item.permissions ||
        item.permissions.some(p => userPermissions.includes(p));

      // Handle submenu recursively
      if (item.submenu) {
        const filteredSubmenu = filterMenuByPermissions(item.submenu, userPermissions);
        return filteredSubmenu.length > 0 && hasPermission
          ? { ...item, submenu: filteredSubmenu }
          : null;
      }

      return hasPermission ? item : null;
    })
    .filter(Boolean);
};

  const filteredMenuItems = filterMenuByPermissions(menuItems, user.permissions);


  const handleMouseEnter = (index) => setVisibleTooltipIndex(index);
  const handleMouseLeave = () => setVisibleTooltipIndex(null);

  const [tv, setTv] = useState([false, false]);

  function minmizeCall() {
    if (callView.isMaxView) {
      const payload = { isMaxView: false, isMinView: true };
      dispatch(setViewData(payload));
    }
  }

  return (
    <>
      <div
        className={`relative top-0 left-0 h-screen transition-all duration-300 ease-in bg-sidebar_bg z-20 ${
          showSidebar ? "w-64" : "w-16"
        }`}
      >
        <button
          className={`absolute -right-3.5 top-[64px] transition-all duration-300 ease-in ${
            showSidebar ? "" : "rotate-180"
          }`}
          onClick={() => {
            setShowSidebar(!showSidebar);
            setShowSubmenu(false);
          }}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="15"
              cy="15"
              r="14.25"
              fill="white"
              stroke="#245CEA"
              strokeWidth="1.5"
            />
            <path
              d="M18 9L12 15L18 21"
              stroke="#245CEA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div
          className={`flex items-center pt-5 transition-all duration-300 ease-in-out ${
            showSidebar ? "px-5 w-full" : "justify-center px-3 ml-2"
          }`}
        >
          <img
            src={showSidebar ? EpicImg : EpicImgSm}
            className={`h-10 w-10 object-contain object-center ${
              showSidebar ? "px-2 w-full" : "w-10"
            }`}
          />
          {/* <span
            className={`text-white text-xl pl-3 font-mont font-[700] text-[19px] overflow-hidden whitespace-nowrap transition-all duration-500 ease-in-out ${showSidebar ? "opacity-100 max-w-[200px]" : "opacity-0 max-w-0"
              }`}
          >
            EPIC Health
          </span> */}
        </div>
        <div className="pt-5 pb-5 overflow-x-hidden">
          <svg
            width="260"
            height="2"
            viewBox="0 0 260 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="260"
              height="1.5"
              fill="url(#paint0_linear_15345_18824)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_15345_18824"
                x1="0"
                y1="0.75"
                x2="260"
                y2="0.75"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#7A0DB4" stopOpacity="0" />
                <stop offset="0.485" stopColor="white" />
                <stop offset="1" stopColor="#7A0DB4" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div className="h-[calc(100vh-102px)]">
          <ul className="h-full flex flex-col">
            {filteredMenuItems.map((item, index) => {
              const hasSubmenu = item.submenu && item.submenu.length > 0;
              const isSubmenuOpen = openSubmenus[index];

              return (
                <li key={item.key || index} className="relative ">
                  <div
                    className={`flex items-center py-2.5 pr-7 menu_hover_color transition duration-200 ${
                      showSidebar ? "pl-5" : "justify-center pl-7"
                    } ${
                      routeName === item.href.slice(1) ? "menu_selected" : ""
                    } `}
                    onClick={() => hasSubmenu && toggleSubmenu(index)}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}
                  >
                    {hasSubmenu ? (
                      <span className={`pl-1 text-base text-white flex`}>
                        <div className="w-[28px]">{item.icon}</div>
                        <div
                          className={`pl-3 ${
                            showSidebar ? "inline-block" : "hidden"
                          }`}
                        >
                          {item.name}
                        </div>
                      </span>
                    ) : (
                      <Link
                        to={item.href}
                        className={`pl-1 text-base text-white flex`}
                        onClick={() => setShowSidebar(false)}
                      >
                        <div className="w-[28px]">{item.icon}</div>
                        <div
                          className={`pl-3 ${
                            showSidebar ? "inline-block" : "hidden"
                          }`}
                        >
                          {item.name}
                        </div>
                      </Link>
                    )}

                    {hasSubmenu && (
                      <button
                        className={`ml-auto transition-transform duration-300 ease-in ${
                          isSubmenuOpen ? "rotate-90" : ""
                        } ${showSidebar ? "inline-block" : "hidden"}`}
                      >
                        {arrowIconSvg}
                      </button>
                    )}

                    {/* Tooltip for parent */}
                    {!showSidebar && visibleTooltipIndex === index && (
                      <div className="absolute left-[70px] bg-black text-white text-sm py-1 px-2 rounded opacity-90 z-10 whitespace-nowrap inline-block">
                        <div className="absolute -left-[5px] top-1/2 transform rotate-180 -translate-y-1/2 border-l-[6px] border-l-black border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent"></div>
                        {item.name}
                      </div>
                    )}
                  </div>

                  {hasSubmenu && (
                    <ul
                      className={`w-full pt-2.5 transition-all duration-300 ease-in ${
                        isSubmenuOpen ? "block" : "hidden"
                      }`}
                    >
                      {item.submenu.map((subitem, subindex) => {
                        const subKey = `${index}-${subindex}`;
                        return (
                          <li
                            key={subKey}
                            className={`relative flex items-center py-2.5 pr-5 ${
                              showSidebar ? "pl-10" : "pl-3"
                            } menu_hover_color transition duration-200 font-[500] ${
                              routeName === subitem.href.slice(1)
                                ? "menu_selected"
                                : ""
                            }`}
                            onClick={() => setShowSidebar(false)}
                            onMouseEnter={() => handleMouseEnter(subKey)}
                            onMouseLeave={handleMouseLeave}
                          >
                            <Link
                              to={subitem.href}
                              className="pl-1 text-base text-white flex items-center"
                            >
                              <div
                                className={`${showSidebar ? "" : "pl-[5px]"}`}
                              >
                                {subitem.icon}
                              </div>
                              <div
                                className={`pl-3 ${
                                  showSidebar ? "inline-block" : "hidden"
                                }`}
                              >
                                {subitem.name}
                              </div>
                            </Link>

                            {/* Tooltip for submenu */}
                            {!showSidebar && visibleTooltipIndex === subKey && (
                              <div className="absolute left-[70px] bg-black text-white text-sm py-1 px-2 rounded opacity-90 z-10 whitespace-nowrap inline-block">
                                <div className="absolute -left-[5px] top-1/2 transform rotate-180 -translate-y-1/2 border-l-[6px] border-l-black border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent"></div>
                                {subitem.name}
                              </div>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Leftbar;
